import EventEmitter from 'events';

const ee = new EventEmitter();

export const EventsActions = {
  getPayload(event, payload) {
    return {
      event,
      timestamp: new Date().getTime(),
      ...payload,
    };
  },
  emit(name, payload) {
    ee.emit(name, payload);
  },
  on(event, listener) {
    if (!event || !listener) return;
    ee.on(event, (emitPayload) => {
      const payload = this.state.actions.events.getPayload(event, emitPayload);
      typeof listener === `function` && listener(payload);
    });
  },
  removeListener(event, listener) {
    ee.removeListener(event, listener);
  },
  removeAllListeners(events) {
    ee.removeAllListeners(events);
  },
};
